// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Permissoes_ResetapermissoesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /permissoes/resetaPermissoes
 * Resets user permissions by calling the permissions-service and clearing the filter cache.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Permissoes_ResetapermissoesResponseDados = boolean;

export type Permissoes_ResetapermissoesResponse = ApiResponse<Permissoes_ResetapermissoesResponseDados>;

registerResponseContract('Permissoes_ResetapermissoesResponse', {})
